import axios from 'axios';

import { Filter, SearchRequest } from 'core/util/Search';
import { ResponseReviewApprovalsYeti } from 'reviews2/bulk-actions/ReviewPendingApprovals.types';
import {
    BulkUpdateRequest,
    ForwardEmailRequest,
    GetReviews3Args,
    PublishRequest,
    YetiReview,
    SetResponseStateArgs,
} from 'reviews2/feed/Reviews.types';

export const getReviews3 = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args?: GetReviews3Args,
): Promise<any[]> => {
    const { data } = await axios.post<any[]>(`/api/tenants/${tenantId}/reviews3`, {
        search,
        args,
    });

    return data;
};

export const getReview3 = async (tenantId: number | undefined, reviewId: string, args?: GetReviews3Args) => {
    const { data } = await axios.get<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}`, {
        params: { args },
    });

    return data;
};

export const getResponse = async (tenantId: number | undefined, responseId: string, args?: GetReviews3Args) => {
    const { data } = await axios.get<any>(`/api/tenants/${tenantId}/reviews3/responses/${responseId}`, {
        params: { args },
    });

    return data;
};

export const deleteResponse = async (tenantId: number | undefined, responseId: string, args?: any) => {
    const { data } = await axios.delete<any>(`/api/tenants/${tenantId}/reviews3/responses/${responseId}`, {
        params: { args },
    });

    return data;
};

export const setLabel = async (tenantId: number | undefined, reviewId: string, labelId: number) => {
    const { data } = await axios.post<YetiReview>(`/api/tenants/${tenantId}/reviews3/${reviewId}/label`, {
        args: { labelId },
    });

    return data;
};

export const unsetLabel = async (tenantId: number | undefined, reviewId: string, labelId: number) => {
    const { data } = await axios.delete<YetiReview>(`/api/tenants/${tenantId}/reviews3/${reviewId}/label`, {
        params: { args: { labelId } },
    });

    return data;
};

export const toggleLabel = async (tenantId: number | undefined, review: any, labelId: number) => {
    if (review.r4e_label_ids?.includes(labelId)) {
        return unsetLabel(tenantId, review.document_id, labelId);
    }

    return setLabel(tenantId, review.document_id, labelId);
};

export const addAttribution = async (tenantId: number | undefined, reviewId: string, args?: any) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}/attribution`, {
        args,
    });

    return data;
};

export const removeAttribution = async (tenantId: number | undefined, reviewId: string, args?: any) => {
    const { data } = await axios.delete<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}/attribution`, {
        params: { args },
    });

    return data;
};

export const publish = async (
    tenantId: number | undefined,
    publishReq: PublishRequest,
    args?: any,
): Promise<ResponseReviewApprovalsYeti> => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/responses/publish`, {
        publishReq,
        args,
    });

    return data;
};

export const reject = async (tenantId: number | undefined, responseId: string, args?: any) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/responses/reject`, {
        responseId,
        args,
    });

    return data;
};

export const getBulkPendingApprovals = async (tenantId: number | undefined, search: any, args?: any) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/pending-approvals`, {
        search,
        args,
    });

    return data;
};

export const bulkUpdateResponseState = async (
    tenantId: number | undefined,
    bulkUpdateReq: BulkUpdateRequest,
    args?: any,
) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/responses/bulk-update-state`, {
        bulkUpdateReq,
        args,
    });

    return data;
};

export const getMetrics = async (tenantId: number | undefined, filters: Filter[], args?: object): Promise<any> => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/reviews3/metrics`, {
        filters,
        args,
    });

    return data;
};

export const forwardEmail = async (
    tenantId: number | undefined,
    forwardEmailRequest: ForwardEmailRequest,
    args: any,
) => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/reviews3/forward-email`, {
        forwardEmailRequest,
        args,
    });

    return data;
};

export const lockReview = async (tenantId: number | undefined, reviewId: string, args?: any) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}/lock`, {
        args,
    });

    return data;
};

export const unlockReview = async (tenantId: number | undefined, reviewId: string, args?: any) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}/unlock`, {
        args,
    });

    return data;
};

export const exportReviews = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args?: object,
): Promise<any> => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/reviews3/export`, {
        search,
        args,
    });

    return data;
};

export const setResponseState = async (
    tenantId: number | undefined,
    responseId: string,
    args: SetResponseStateArgs,
) => {
    const { data } = await axios.post<any>(`/api/tenants/${tenantId}/reviews3/responses/${responseId}/set-state`, {
        args,
    });

    return data;
};

export const getReviewHistory = async (tenantId: number | undefined, reviewId: string, args?: any) => {
    const { data } = await axios.get<any>(`/api/tenants/${tenantId}/reviews3/${reviewId}/history`, {
        params: { args },
    });

    return data;
};
